import Vue from 'vue';
import Vuex from 'vuex';

import * as modules from './modules';

import admin from './admin';

const storeModules = {
	...modules,
	admin,
};

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: storeModules,

	/*
	 * Enable strict mode (adds overhead!)
	 * for dev mode only
	 */
	strict: process.env.DEV,
});

/*
 * HMR magic. Notice we guard this
 * code with "process.env.DEV" -- so this doesn't
 * get into the production build.
 */
if (process.env.DEV && module.hot) {
	module.hot.accept(['./modules', './admin'], () => {
		store.hotUpdate({ modules: {
			...require('./modules'),
			admin: require('./admin'),
		} });
	});
}

const modulesArray = Object.keys(modules);

export { modulesArray as modules };

export default store;
